import Resource from '@/api/Resource';
import api from '@/api';

export default class Presentation extends Resource {
  $name = 'presentations';

  $defaults() {
    return {
      id: null,
      slides: [],
    };
  }

  $save() {
    return Promise.all([this.deleteSlides(), this.updateSlides(), this.addNewSlides()]);
  }

  deleteSlides() {
    // @todo delete multiple slides at once
    const slidesToDelete = this.$.slides.filter(originalSlide => {
      return !this.slides.find(slide => slide.id === originalSlide.id);
    });

    return Promise.all(
      slidesToDelete.map(slide => {
        return api.for('slides').delete(slide.id);
      })
    );
  }

  updateSlides() {
    // @todo update multiple slides at once
    const slidesToUpdate = this.slides.filter(slide => {
      const originalSlide = this.$.slides.find(originalSlide => originalSlide.id === slide.id);

      if (!originalSlide) {
        return false;
      }

      return slide.title !== originalSlide.title || slide.order !== originalSlide.order;
    });

    return Promise.all(
      slidesToUpdate.map(slide => {
        return api.for('slides').update(slide.id, {
          title: slide.title,
          order: slide.order,
        });
      })
    );
  }

  addNewSlides() {
    // @todo maybe create multiple slides at once
    const newSlides = this.slides.filter(slide => {
      return !this.$.slides.find(originalSlide => originalSlide.id === slide.id);
    });

    return Promise.all(
      newSlides.map(slide => {
        return api.for('slides').create({
          presentation_id: this.id,
          title: slide.title,
          order: slide.order,
          image_path: slide.file,
        });
      })
    );
  }
}
